import * as coreApi from "api/Core";
import GenericList from 'components/GenericList';
import MuiDanger from 'components/MuiExtras/Typography/MuiDanger';
import MuiSuccess from 'components/MuiExtras/Typography/MuiSuccess';
import { GenericListItemDto, KnowledgeTestWhoGotRightDto } from 'models/ApiModels';
import * as React from 'react';
import { useTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    testId: string;
    onClose: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const WhoAnsweredKnowledgeTestDrawer: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    const { testId, onClose } = props;

    return <GenericList
        title={t("Views.KnowledgeTest.Dialogs.WhoAnsweredKnowledgeTestDrawer.BoxTitle")}
        showThumbnail={true}
        variant="drawer"
        onGetData={(searchText: string, offset: number, take: number) => coreApi.getWhoAnsweredTest(testId, searchText, offset, take)}
        onRenderName={
            (i: GenericListItemDto) => {
                const item = i as KnowledgeTestWhoGotRightDto;
                return item.totalCorrect > 0
                    ? <MuiSuccess>{item.name}</MuiSuccess>
                    : <MuiDanger>{item.name}</MuiDanger>;
            }
        }
        onRenderSecondLine={
            (i: GenericListItemDto) => {
                const item = i as KnowledgeTestWhoGotRightDto;
                return <><b>{(100.0 * item.totalCorrect / item.totalAnswers).toFixed(1)}%</b> <span>({item.totalCorrect}/{item.totalAnswers})</span></>;
            }
        }
        onClose={onClose}
    />;

};

export default WhoAnsweredKnowledgeTestDrawer;